export default "__VITE_ASSET__B83nsoUF__"